import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
  selector: 'dependency-header',
  template: require('./dependency.header.directive.html')
})
export class DependencyHeaderComponent {
  @Input() items: any[];

  constructor(public stateService: StateService) {}

  allItemsClosed(items: any[]): boolean {
    return this.closedItemCount(items) === _.size(items);
  }

  closedItemCount(items: any[]): number {
    return _.filter(items, { statusId: 0 }).length;
  }
}
